import { createPinia, PiniaVuePlugin, setActivePinia } from "pinia";
import Vue from "vue";
import { worker } from "@erp/mocks/browser";
import { VueQueryPlugin } from "@tanstack/vue-query";
import VueRouter from "vue-router";
import PortalVue from "portal-vue";
import Decimal from "decimal.js";
import { queryClient, ERPInfoPlugin, vuetify } from "./plugins";
import { initNestServer } from "./api";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
// Decimal.js 설정
Decimal.set({
    precision: 20,
    rounding: Decimal.ROUND_HALF_UP,
});
export async function bootstrap(config) {
    const { default: router } = await config.routerImport();
    initNestServer(process.env.VUE_APP_NEST_SERVER_URL);
    if (process.env.NODE_ENV === "production") {
        Vue.config.silent = true;
        // console.error, console.warn은 프로덕션에서도 유지 (에러 추적용)
        console.log = function () { };
        console.info = function () { };
    }
    else if (process.env.NODE_ENV === "development" &&
        process.env.VUE_APP_MSW === "true") {
        worker.start();
    }
    // 글로벌 에러 바운더리: Vue 컴포넌트 렌더링 에러 캐치
    Vue.config.errorHandler = (err, vm, info) => {
        console.error(`[Vue Error] ${info}:`, err);
    };
    // 비동기 미처리 rejection 캐치
    window.addEventListener("unhandledrejection", (event) => {
        console.error("[Unhandled Rejection]", event.reason);
    });
    const pinia = createPinia();
    setActivePinia(pinia);
    Vue.config.productionTip = false;
    Vue.prototype.$vuetify = vuetify.framework;
    Vue.use(VueRouter);
    Vue.use(PiniaVuePlugin);
    Vue.use(VueQueryPlugin, { queryClient });
    Vue.use(PortalVue);
    Vue.use(ERPInfoPlugin, config.erpInfo);
    Vue.use(VueViewer, {
        defaultOptions: {},
    });
    new Vue({
        vuetify,
        pinia,
        router,
        render: (h) => h(config.App),
    }).$mount("#app");
}
